export default {
  common: {
    brand: 'USFans Spreadsheet',
    nav: {
      home: 'Home',
      categories: 'Categories',
      guides: 'Guides',
      shoppingGuide: 'Shopping Guide',
      safety: 'Safety',
      faq: 'FAQ',
    },
    cta: {
      spreadsheet: 'usfans spreadsheet',
      buyNow: 'buy it now',
      explore: 'Explore USFans Spreadsheet',
      browseDirectory: 'Browse the directory',
    },
    search: {
      placeholder: 'Search USFans Spreadsheet, products, categories or guides…',
    },
    language: 'Language',
    footer: {
      tagline: 'An independent resource hub helping you find, compare and explore USFans Spreadsheet resources — organized, updated and multilingual.',
      resources: 'Resources',
      resourcesGuides: 'Guides',
      resourcesCategories: 'Categories',
      resourcesSafety: 'Safety guide',
      resourcesFaq: 'FAQ',
      company: 'Company',
      about: 'About',
      editorialPolicy: 'Editorial policy',
      contact: 'Contact',
      legal: 'Legal',
      privacy: 'Privacy policy',
      terms: 'Terms',
      disclaimer: 'Disclaimer',
      rights: 'All rights reserved.',
    },
    languages: {
      en: 'English',
      pl: 'Polski',
      es: 'Español',
      fr: 'Français',
    },
  },
};